import { DashboardPendingCall } from "../../pages/api/dashboard";
import Link from "next/link";
import { formatDistanceToNow } from "date-fns";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { da, enUS, nb, sv } from "date-fns/locale";

interface PendingCallsProps {
  calls: DashboardPendingCall[];
}

const localeMap: Record<string, Locale> = {
  da: da,
  en: enUS,
  no: nb,
  sv: sv,
};

export default function PendingCalls({ calls }: PendingCallsProps) {
  const { t } = useTranslation();
  const router = useRouter();
  const dateLocale = localeMap[router.locale || "en"] || enUS;

  return (
    <div className="card h-100">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h6 className="mb-0">
          {t("dashboard.pendingCallsFromCallSheet")}{" "}
          {calls.length > 0 && (
            <span className="badge bg-warning text-dark">{calls.length}</span>
          )}
        </h6>
        <Link href="/calls" className="btn btn-sm btn-outline-primary">
          {t("dashboard.seeAll")}
        </Link>
      </div>
      <div className="card-body p-0">
        {calls.length === 0 ? (
          <p className="text-muted p-3 mb-0">{t("dashboard.noPendingCalls")}</p>
        ) : (
          <ul className="list-group list-group-flush">
            {calls.slice(0, 5).map((call) => (
              <li
                key={call.id}
                className="list-group-item d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <div className="fw-bold">
                    {call.name || call.email || t("dashboard.unknown")}
                  </div>
                  <small className="text-muted">
                    {call.phone && <span>{call.phone}</span>}
                    {call.channel && (
                      <span className="ms-2 badge bg-secondary">
                        {call.channel}
                      </span>
                    )}
                  </small>
                </div>
                <div className="text-end">
                  <small className="text-muted d-block">
                    {formatDistanceToNow(new Date(call.createdAt), {
                      addSuffix: true,
                      locale: dateLocale,
                    })}
                  </small>
                  {call.assigneeName && (
                    <small className="text-info">{call.assigneeName}</small>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
